import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _mutations, _actions;

import axios from 'axios';
import { API_GET_BANNER_LIST, API_GET_RECOMMEND_LIST, API_GET_HOTSHOP_LIST, API_GET_YELLOW_STRIP, API_GET_BATCHFETCH_LIST } from '@/apis';
import { GET_BANNER_LIST, RENDER_BANNER_LIST, GET_RECOMMEND_LIST, GET_NEXT_PAGE, NEXT_PAGE, RENDER_RECOMMEND_LIST, SELECT_SORT_TYPE, SORT_RECOMMEND_LIST, TOGGLE_SUB_SORT, SORT_SUB_TYPE, SELECT_SUB_TYPE, CLICK_MASK, CLOSE_SUB_SORT, TOGGLE_LOADING_STATE, GET_HOTSHOP_LIST, GET_YELLOW_STRIP, RENDER_HOTSHOP_LIST, GET_BATCHFETCH_LIST, RENDER_BATCHFETCH_LIST, MUTATE_PAGE_TO_INIT, RENDER_YELLOW_STRIP } from '@/constants/home';
import Drip from 'drip';
var sellChannel = (Drip.constant || {}).appType;
export default {
  state: {
    page: 1,
    category: 0,
    sortId: 4,
    subSortType: 0,
    size: 10,
    recommendList: [],
    isLoading: false,
    sortTypes: [{
      sortId: 4,
      name: '当前热门',
      selected: true,
      subs: []
    }, {
      sortId: 1,
      name: '最新上架',
      selected: false,
      subs: []
    }, {
      sortId: 5,
      name: '折扣演出',
      selected: false,
      subs: []
    }, {
      sortId: -1,
      name: '全部时间',
      selected: false,
      subs: [{
        subId: 0,
        name: '全部时间',
        current: true
      }, {
        subId: 1,
        name: '今天',
        current: false
      }, {
        subId: 2,
        name: '明天',
        current: false
      }, {
        subId: 3,
        name: '本周末',
        current: false
      }, {
        subId: 4,
        name: '一周内',
        current: false
      }, {
        subId: 5,
        name: '一个月内',
        current: false
      }]
    }],
    bachfetchList: {},
    yellowStripInfo: null,
    bannerList: [],
    subTypes: [],
    showSubTypes: false,
    prev: {
      sortIndex: 0,
      subIndex: 0,
      parentIndex: null
    },
    hotShopList: [],
    pageNo: 1,
    pageSize: 2,
    performanceNumber: 2,
    type: 1,
    hasMore: true
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, RENDER_BANNER_LIST, function (state, payload) {
    state.bannerList = payload;
  }), _defineProperty(_mutations, RENDER_RECOMMEND_LIST, function (state, _ref) {
    var list = _ref.list,
        hasMore = _ref.hasMore,
        isConcat = _ref.isConcat;

    if (isConcat) {
      state.recommendList = state.recommendList.concat(list);
    } else {
      var recommendList = [];
      var recommendShowList = [];
      list.forEach(function (item) {
        item.isCurrentCity === 1 ? recommendList.push(item) : recommendShowList.push(item); // 区分当前城市演出和推荐城市演出
      });
      state.recommendList = recommendList;
      state.recommendShowList = recommendShowList;
    }

    state.recommendList.forEach(function (item) {
      if ([1, 3, 12].indexOf(sellChannel) > -1 && item.shopUUId) {
        item.shopId = item.shopUUId;
      }
    });
    state.hasMore = hasMore;
  }), _defineProperty(_mutations, SORT_RECOMMEND_LIST, function (state, _ref2) {
    var sort = _ref2.sort,
        index = _ref2.index; // 如果选项含有子排序列表, 不改变 sortId

    if (sort.subs.length) {
      state.subTypes = sort.subs;
      state.prev.parentIndex = index;
    } else {
      state.sortTypes[state.prev.sortIndex].selected = false;
      state.sortTypes[index].selected = true;
      state.sortId = sort.sortId;
      state.prev.sortIndex = index; // 切换筛选条件时重置页数

      state.page = 1;
    }
  }), _defineProperty(_mutations, SORT_SUB_TYPE, function (state, _ref3) {
    var sub = _ref3.sub,
        index = _ref3.index;
    state.subSortType = sub.subId;
    state.subTypes[state.prev.subIndex].current = false;
    state.subTypes[index].current = true;
    state.prev.subIndex = index;
    state.sortTypes[state.prev.parentIndex].name = sub.name; // 切换筛选条件时重置页数

    state.page = 1;
  }), _defineProperty(_mutations, TOGGLE_SUB_SORT, function (state) {
    state.showSubTypes = !state.showSubTypes;
  }), _defineProperty(_mutations, CLOSE_SUB_SORT, function (state) {
    state.showSubTypes = false;
  }), _defineProperty(_mutations, NEXT_PAGE, function (state) {
    state.page++;
  }), _defineProperty(_mutations, TOGGLE_LOADING_STATE, function (state, payload) {
    state.isLoading = payload !== undefined ? payload : !state.isLoading;
  }), _defineProperty(_mutations, RENDER_HOTSHOP_LIST, function (state, payload) {
    state.hotShopList = payload;
    state.hotShopList.forEach(function (item) {
      if ([1, 3, 12].indexOf(sellChannel) > -1 && item.shopUUId) {
        item.shopId = item.shopUUId;
      }
    }); // console.log('RENDER_HOTSHOP_LIST: ' + JSON.stringify(payload))
  }), _defineProperty(_mutations, RENDER_BATCHFETCH_LIST, function (state, payload) {
    state.bachfetchList = payload; // console.log(state.bachfetchList)
    // console.log('RENDER_BATCHFETCH_LIST: ' + JSON.stringify(payload))
  }), _defineProperty(_mutations, MUTATE_PAGE_TO_INIT, function (state) {
    state.page = 1;
  }), _defineProperty(_mutations, RENDER_YELLOW_STRIP, function (state, payload) {
    state.yellowStripInfo = payload;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, GET_BANNER_LIST, function (_ref4) {
    var commit = _ref4.commit;
    axios.get("".concat(API_GET_BANNER_LIST, "/SI-1")).then(function (_ref5) {
      var code = _ref5.code,
          data = _ref5.data;
      commit(RENDER_BANNER_LIST, data);
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, GET_RECOMMEND_LIST, function (_ref6, isConcat) {
    var commit = _ref6.commit,
        state = _ref6.state;
    commit(TOGGLE_LOADING_STATE);
    if (!isConcat) commit(MUTATE_PAGE_TO_INIT);
    axios.get("".concat(API_GET_RECOMMEND_LIST, "/").concat(state.category, ";st=").concat(state.sortId, ";p=").concat(state.page, ";s=").concat(state.size, ";tft=").concat(state.subSortType)).then(function (_ref7) {
      var code = _ref7.code,
          data = _ref7.data,
          paging = _ref7.paging;

      if (code === 200) {
        commit(RENDER_RECOMMEND_LIST, {
          list: data,
          hasMore: paging && paging.hasMore,
          isConcat: !!isConcat // 如果是第一页, 替换原有数据; 如果不是第一页, 连接原有数据

        });
      }

      commit(TOGGLE_LOADING_STATE);
    }).catch(function (err) {
      if (err) console.log(err.message);
      commit(TOGGLE_LOADING_STATE);
    });
  }), _defineProperty(_actions, SELECT_SORT_TYPE, function (_ref8, _ref9) {
    var commit = _ref8.commit,
        state = _ref8.state;
    var sort = _ref9.sort,
        index = _ref9.index; // 有子排序就 toggle, 没有就关闭

    commit(sort.subs.length ? TOGGLE_SUB_SORT : CLOSE_SUB_SORT);
    commit(SORT_RECOMMEND_LIST, {
      sort: sort,
      index: index
    });
  }), _defineProperty(_actions, SELECT_SUB_TYPE, function (_ref10, _ref11) {
    var commit = _ref10.commit;
    var sub = _ref11.sub,
        index = _ref11.index;
    commit(SORT_SUB_TYPE, {
      sub: sub,
      index: index
    });
    commit(TOGGLE_SUB_SORT);
  }), _defineProperty(_actions, CLICK_MASK, function (_ref12) {
    var commit = _ref12.commit;
    commit(CLOSE_SUB_SORT);
  }), _defineProperty(_actions, GET_NEXT_PAGE, function (_ref13) {
    var commit = _ref13.commit;
    commit(NEXT_PAGE);
  }), _defineProperty(_actions, GET_HOTSHOP_LIST, function (_ref14) {
    var commit = _ref14.commit,
        state = _ref14.state;
    axios.get("".concat(API_GET_HOTSHOP_LIST, "&pageNo=").concat(state.pageNo, "&pageSize=").concat(state.pageSize, "&performanceNumber=").concat(state.performanceNumber)).then(function (res) {
      commit(RENDER_HOTSHOP_LIST, res.data); // console.log('RENDER_HOTSHOP_LIST: ' + JSON.stringify(res.data))
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, GET_BATCHFETCH_LIST, function (_ref15) {
    var commit = _ref15.commit,
        state = _ref15.state;
    axios.get("".concat(API_GET_BATCHFETCH_LIST, "positionList=SI-1,my_homepage_zhongtong,my_homepage_rb1,my_homepage_rb2")).then(function (_ref16) {
      var code = _ref16.code,
          data = _ref16.data;
      code === 200 && data && commit(RENDER_BATCHFETCH_LIST, data); // console.log('RENDER_BATCHFETCH_LIST: ' + JSON.stringify(res.data))
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, GET_YELLOW_STRIP, function (_ref17) {
    var commit = _ref17.commit,
        state = _ref17.state;
    axios.get("".concat(API_GET_YELLOW_STRIP)).then(function (_ref18) {
      var code = _ref18.code,
          data = _ref18.data;
      code === 200 && commit(RENDER_YELLOW_STRIP, data);
    }).catch(function (err) {
      console.warn(err);
    });
  }), _actions)
};